/**************************************************
 * Nombre:       Seccion_Detalle_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Detalle_Producto_Img_Caracteristicas from "./Componentes/Detalle_Producto_Img_Caracteristicas";
import Detalle_Producto_Match from "./Componentes/Detalle_Producto_Match";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {useParams} from "react-router";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {irArriba} from "../../Utilidades/irArriba";
import Home_Suscripcion from "./Componentes/Home_Suscripcion";

const Seccion_Detalle_Producto = () => {
    const {sCell} = useResponsive()
    const parms = useParams()
    const [producto, setProducto] = useState({})
    const [id, setId] = useState('')


    useEffect(() => {


        if (parms && parms.id && id !== parms.id) {
            irArriba()
            setId(parms.id)
            obtenerDoc('productos', parms.id).then((dox) => {
                if (dox.res) {
                    setProducto(dox.data)
                }
            })
        }

    }, [parms]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 6}}>
                <Detalle_Producto_Img_Caracteristicas producto={producto}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 18}}>
                <Detalle_Producto_Match producto={producto}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: sCell ? 8 : 14, mb: 12}}>
                <Home_Suscripcion/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Detalle_Producto